import { IRootState } from "..";
import { LOCALSTORAGE_KEY } from "../../config/params";

export const saveToLocalStorage = (state: IRootState) => {
  localStorage.setItem(LOCALSTORAGE_KEY, JSON.stringify({
    stepper: state.stepper,
    user: state.user,
    wellnessPurchaseData: state.wellnessPurchaseData,
  }));
};

export const loadFromLocalStorage = () => {
  try {
    const serialisedState = localStorage.getItem(LOCALSTORAGE_KEY);

    if (serialisedState === null) {
      return undefined;
    }

    return JSON.parse(serialisedState);
  } catch (error) {
    return undefined;
  }
};
